import { Label } from "@/components/_ui/label";
import { Switch } from "@/components/_ui/switch";
import { RowData } from "@tanstack/react-table";

import { useDatatableContext } from "../use-datatable-context";

export function DatatableDisplayOptionsHeaderVisibilitySwitch<TData extends RowData>() {
  const { state, setState } = useDatatableContext<TData>();
  const { showColumnHeaders } = state;

  const handleShowHeaderSwitch = (newCheckValue: boolean) => {
    setState({ showColumnHeaders: newCheckValue });
  };

  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <Label
        htmlFor="toggle-visibility-table-headers"
        className="mb-2 mr-4 w-44 text-xs font-medium text-muted-foreground"
      >
        Spaltentitel anzeigen
      </Label>
      <Switch
        id="toggle-visibility-table-headers"
        checked={showColumnHeaders}
        onCheckedChange={handleShowHeaderSwitch}
        size="sm"
      />
    </div>
  );
}
